(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (root.dataset.clubsubInit === '1') return;
    root.dataset.clubsubInit = '1';

    var data = {
      variantId: parseInt(root.dataset.variantId, 10) || 0,
      sellingPlanId: root.dataset.sellingPlanId || '',
      pricePerBag: parseInt(root.dataset.pricePerBag, 10) || 0,
      moneyFormat: root.dataset.moneyFormat || '{{amount}} €',
      coffeeName: root.dataset.coffeeName || '',
      savingText: root.dataset.savingText || '',
      autoMs: parseInt(root.dataset.autoplay, 10) || 6000
    };
    var hints = (root.dataset.sizeHints || '').split('|').map(function (s) { return s.trim(); });
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fmtMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return (data.moneyFormat || '{{amount}} €').replace(/\{\{\s*amount[^}]*\}\}/g, amount);
    }

    var titleEl = root.querySelector('[data-clubsub-split]');
    if (titleEl && !titleEl.dataset.split) {
      titleEl.dataset.split = '1';
      var text = titleEl.textContent.trim();
      var words = text.split(/\s+/);
      titleEl.textContent = '';
      var accentSet = ['origen,', 'origen', 'origen.'];
      words.forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'clubsub__word';
        if (accentSet.indexOf(w.toLowerCase()) >= 0) span.className += ' clubsub__word--accent';
        span.style.setProperty('--i', i);
        span.textContent = w;
        titleEl.appendChild(span);
        if (i < words.length - 1) titleEl.appendChild(document.createTextNode(' '));
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('is-loaded');
      });
    });

    var marqueeTrack = root.querySelector('[data-clubsub-marquee]');
    if (marqueeTrack && !marqueeTrack.dataset.cloned) {
      marqueeTrack.dataset.cloned = '1';
      marqueeTrack.innerHTML = marqueeTrack.innerHTML + marqueeTrack.innerHTML;
    }

    var qty = 0;
    var comparePrice = 0;
    var sizeLabel = '';
    var sizeIndex = 0;
    var grindValue = '';
    var sizeBtns = root.querySelectorAll('[data-clubsub-size]');
    var qtyHintEl = root.querySelector('[data-clubsub-qty-hint]');
    var totalEl = root.querySelector('[data-clubsub-total]');
    var compareEl = root.querySelector('[data-clubsub-compare]');
    var savingEl = root.querySelector('[data-clubsub-saving]');
    var ctaEl = root.querySelector('[data-clubsub-cta]');
    var methodBtns = root.querySelectorAll('[data-clubsub-method]');

    var firstMethod = methodBtns[0];
    if (firstMethod) grindValue = firstMethod.getAttribute('data-value') || '';
    var grindSelect = root.querySelector('[data-clubsub-grind-select]');
    if (grindSelect) {
      grindValue = grindSelect.value || '';
      grindSelect.addEventListener('change', function () {
        grindValue = grindSelect.value || '';
      });
    }

    function updateHint() {
      if (!qtyHintEl) return;
      qtyHintEl.classList.add('is-fade');
      setTimeout(function () {
        qtyHintEl.textContent = hints[sizeIndex] || '';
        qtyHintEl.classList.remove('is-fade');
      }, 200);
    }

    function renderTotal() {
      if (!totalEl) return;
      var price = data.pricePerBag * qty;
      var saving = comparePrice > price ? comparePrice - price : 0;
      totalEl.textContent = fmtMoney(price);
      if (compareEl) compareEl.textContent = saving ? fmtMoney(comparePrice) : '';
      if (savingEl) {
        savingEl.hidden = !saving || !data.savingText;
        if (saving) {
          savingEl.textContent = data.savingText
            .replace('[importe]', fmtMoney(saving))
            .replace('[porcentaje]', Math.floor(saving * 100 / comparePrice) + '%');
        }
      }
    }

    function selectSize(btn) {
      sizeBtns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked', 'true');
      qty = parseInt(btn.getAttribute('data-bags'), 10) || 0;
      comparePrice = parseInt(btn.getAttribute('data-compare'), 10) || 0;
      sizeLabel = btn.getAttribute('data-label') || '';
      sizeIndex = parseInt(btn.getAttribute('data-index'), 10) || 0;
      updateHint();
      renderTotal();
    }

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { selectSize(btn); });
    });

    methodBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        methodBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        grindValue = btn.getAttribute('data-value') || '';
      });
    });

    if (ctaEl) {
      var labelEl = ctaEl.querySelector('[data-clubsub-cta-label]');
      var originalText = labelEl ? labelEl.textContent : '';
      var resetCta = function () {
        ctaEl.removeAttribute('disabled');
        if (labelEl) labelEl.textContent = originalText;
      };
      // Al volver atrás desde el carrito, el navegador restaura la página de su caché con el botón aún en «Añadiendo…»
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) resetCta();
      });

      ctaEl.addEventListener('click', function () {
        if (ctaEl.hasAttribute('disabled')) return;
        if (!data.variantId || !data.sellingPlanId || !qty) return;
        ctaEl.setAttribute('disabled', 'disabled');
        if (labelEl) labelEl.textContent = 'Añadiendo…';

        var payload = {
          id: data.variantId,
          quantity: qty,
          selling_plan: data.sellingPlanId,
          properties: {}
        };
        if (data.coffeeName) payload.properties['Café'] = data.coffeeName;
        if (sizeLabel) payload.properties['Cantidad'] = sizeLabel;
        if (grindValue) payload.properties['Molienda'] = grindValue;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          window.location.href = '/cart';
        }).catch(function (err) {
          resetCta();
          var msg = (err && err.description) ? err.description : 'No se pudo añadir a la suscripción.';
          alert(msg);
        });
      });
    }

    var initialSize = root.querySelector('[data-clubsub-size].is-active') || sizeBtns[0];
    if (initialSize) selectSize(initialSize);

    if (!prefersReduced) {
      root.querySelectorAll('[data-magnetic]').forEach(function (el) {
        var rect;
        el.addEventListener('mouseenter', function () { rect = el.getBoundingClientRect(); });
        el.addEventListener('mousemove', function (e) {
          if (!rect) rect = el.getBoundingClientRect();
          var x = (e.clientX - rect.left - rect.width / 2) * 0.08;
          var y = (e.clientY - rect.top - rect.height / 2) * 0.18;
          el.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; rect = null; });
      });
    }

    var carousel = root.querySelector('[data-clubsub-carousel]');
    if (carousel) {
      var track = carousel.querySelector('[data-clubsub-track]');
      var slides = carousel.querySelectorAll('.clubsub__carousel-slide');
      var dots = carousel.querySelectorAll('[data-slide-to]');
      var caption = carousel.querySelector('[data-clubsub-carousel-caption]');
      var prevBtn = carousel.querySelector('[data-clubsub-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-clubsub-carousel-next]');
      var current = 0;
      var autoTimer = null;
      var isPaused = false;
      var total = slides.length;

      if (caption && slides[0]) caption.textContent = slides[0].getAttribute('data-caption') || '';

      function goTo(i) {
        current = (i + total) % total;
        if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
        dots.forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === current);
          d.setAttribute('aria-selected', idx === current ? 'true' : 'false');
        });
        var newCap = slides[current].getAttribute('data-caption');
        if (newCap && caption) {
          var anim = caption.animate(
            [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-4px)' }],
            { duration: 220, easing: 'ease-out' }
          );
          anim.onfinish = function () {
            caption.textContent = newCap;
            caption.animate(
              [{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }],
              { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
            );
          };
        }
      }
      function startAuto() {
        stopAuto();
        if (data.autoMs <= 0 || total <= 1) return;
        autoTimer = setInterval(function () { if (!isPaused) goTo(current + 1); }, data.autoMs);
      }
      function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }

      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(current - 1); startAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(current + 1); startAuto(); });
      dots.forEach(function (d, idx) {
        d.addEventListener('click', function (e) { e.stopPropagation(); goTo(idx); startAuto(); });
      });
      carousel.addEventListener('mouseenter', function () { isPaused = true; });
      carousel.addEventListener('mouseleave', function () { isPaused = false; });

      var touchStartX = null;
      carousel.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
      carousel.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var diff = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(diff) > 40) {
          if (diff < 0) goTo(current + 1); else goTo(current - 1);
          startAuto();
        }
        touchStartX = null;
      });
      startAuto();

      var lightbox = root.querySelector('[data-clubsub-lightbox]');
      if (lightbox) {
        var lightboxImg = lightbox.querySelector('[data-clubsub-lightbox-img]');
        var lightboxClose = lightbox.querySelector('[data-clubsub-lightbox-close]');
        carousel.addEventListener('click', function (e) {
          if (e.target.closest('.clubsub__carousel-arrow') || e.target.closest('.clubsub__carousel-dot')) return;
          var active = carousel.querySelector('.clubsub__carousel-slide.is-active img');
          if (!active) return;
          lightboxImg.src = active.src;
          lightboxImg.alt = active.alt;
          lightbox.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
        function closeLightbox() {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
        }
        if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
        });
      }
    }

    root.querySelectorAll('[data-clubsub-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.clubsub__faq-item');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });
      root.querySelectorAll('.clubsub__reveal').forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll('.clubsub__reveal').forEach(function (el) { el.classList.add('is-visible'); });
    }

    var progressBar = root.querySelector('[data-clubsub-progress]');
    function updateProgress() {
      if (!progressBar) return;
      var rect = root.getBoundingClientRect();
      var winH = window.innerHeight;
      var total = rect.height - winH;
      if (total <= 0) { progressBar.style.width = '100%'; return; }
      var scrolled = -rect.top;
      var pct = Math.min(100, Math.max(0, (scrolled / total) * 100));
      progressBar.style.width = pct + '%';
    }
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  function initAll() {
    document.querySelectorAll('[data-clubsub]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
